<script lang="ts">
    import Button from "../shared/Button.svelte";
    import Icon from "../shared/Icon.svelte";

    import { getContext, onMount } from "svelte";
    import type { Writable } from "svelte/store";
    import type { SkinState, State } from "../../types/state";

    let skinState: Writable<SkinState> = getContext("skinState");
    let state: Writable<State> = getContext("playerState");

    let settingsButton;
    onMount(() => {
        $skinState.setFocusOnSettingsButton = setFocusOnSettingsButton;
    });
    $: isOpen = $skinState.isSettingsOpen;

    function onClick() {
        $skinState.isSettingsOpen = !$skinState.isSettingsOpen;
        $skinState.showHiddenMenu =
            $skinState.isShiftKeyPressed && $skinState.isSettingsOpen;

        if ($skinState.isSettingsOpen) {
            $state.playerContainer.focus();
        }
    }

    function setFocusOnSettingsButton() {
        settingsButton.focus();
    }
</script>

<Button
    on:click={onClick}
    label="open/close settings"
    bind:that={settingsButton}
>
    <div class="rotate-icon" class:isOpen>
        <Icon type="more" />
    </div>
</Button>

<style lang="scss">
    .rotate-icon {
        &.isOpen {
            transform: rotate(90deg);
        }
        transition: all 0.4s ease-in-out;
    }
</style>
